module.exports = __webpack_public_path__ + "static/media/BM_PreventMaint.52901fe1.svg";